module.exports = __webpack_public_path__ + "static/img/6bg_8.936cd65.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/6bg_8.png
// module id = 743
// module chunks = 1